import {
    SHOW_HUD,
    HIDE_HUD
} from "../store/types";

export const INITIAL_STATE = {
    open: false,
    msg: null,
    severity: 'error'
}

export const hudreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SHOW_HUD:
            return {
                ...state,
                open: true,
                msg: action.payload.msg,
                severity: action.payload.severity || 'error'
            };
        case HIDE_HUD:
            return {
                ...state,
                open: false
            };
        default:
            return state;
    }
};
